import { render, staticRenderFns } from "./ScrollyVideo.vue?vue&type=template&id=922dc2ca&"
import script from "./ScrollyVideo.vue?vue&type=script&lang=js&"
export * from "./ScrollyVideo.vue?vue&type=script&lang=js&"
import style0 from "./ScrollyVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports